<template>
    <v-dialog v-model="dialogInterno" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar color="primary" class="text-h6 white--text" elevation="0">
                <v-icon class="mr-2" color="white">description</v-icon>
                {{ elemento ? elemento.nome + elemento.estensione : "" }}
                <v-spacer />
                <v-icon color="white" @click="chiudi()">close</v-icon>
            </v-toolbar>
            <v-card-text class="mt-5">
                <v-progress-linear v-if="loading" indeterminate color="primary" />
                <v-alert v-if="errore" type="error">{{ errore }}</v-alert>
                <div v-if="!loading && !errore" class="anteprima-contenuto" v-html="contenutoHtml"></div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { download_file } from "@/api/api.dati.js";
import mammoth from "mammoth";

var XLSX = require("xlsx");

export default {
    props: {
        dialog: { type: Boolean, default: false },
        elemento: { type: Object, default: null },
    },

    data: () => ({
        loading: false,
        errore: "",
        contenutoHtml: "",
    }),

    computed: {
        dialogInterno: {
            get() {
                return this.dialog;
            },
            set(value) {
                if (!value) this.chiudi();
            },
        },
    },

    watch: {
        dialog(nuovo) {
            if (nuovo) this.carica();
        },
    },

    methods: {
        async carica() {
            this.loading = true;
            this.errore = "";
            this.contenutoHtml = "";

            try {
                const par = "?path=" + encodeURIComponent(this.elemento.path);
                const res = await download_file(par);
                const buffer = await res.data.arrayBuffer();
                const estensione = (this.elemento.estensione || "").toLowerCase();

                if (estensione === ".docx") {
                    const risultato = await mammoth.convertToHtml({ arrayBuffer: buffer });
                    this.contenutoHtml = risultato.value;
                } else if (estensione === ".xlsx" || estensione === ".xls" || estensione === ".csv") {
                    const workbook = XLSX.read(buffer, { type: "array" });
                    const primoFoglio = workbook.SheetNames[0];
                    this.contenutoHtml = XLSX.utils.sheet_to_html(workbook.Sheets[primoFoglio]);
                } else {
                    this.errore = "Formato non supportato per l'anteprima";
                }
            } catch (error) {
                console.error(error);
                this.errore = "Impossibile generare l'anteprima del documento";
            } finally {
                this.loading = false;
            }
        },

        chiudi() {
            this.$emit("chiudi");
        },
    },
};
</script>

<style scoped>
.anteprima-contenuto {
    max-width: 900px;
    margin: 0 auto;
    background: white;
    padding: 20px;
    overflow-x: auto;
}

.anteprima-contenuto>>>table {
    border-collapse: collapse;
}

.anteprima-contenuto>>>td,
.anteprima-contenuto>>>th {
    border: 1px solid #ddd;
    padding: 4px 8px;
}
</style>
